import { render, staticRenderFns } from "./NewDepthChartForm.vue?vue&type=template&id=1c12f2d1&"
import script from "./NewDepthChartForm.vue?vue&type=script&lang=ts&"
export * from "./NewDepthChartForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports